"use client";

import React from "react";

// Styles
import * as S from "./styles";

// Components
import { DropdownMenuItem, DropdownMenuSeparator } from "../ui/dropdown-menu";
import { LogOut, User } from "lucide-react";
import { UseAuth, useUser } from "@/hooks";
import { clearFormStorage } from "@/utils/clearFormStorage";

interface DropdownProfileProps {
  onOpenModal: () => void;
}

const DropdownProfile: React.FC<DropdownProfileProps> = ({ onOpenModal }) => {
  const { handleLogout } = UseAuth();
  const { user } = useUser();
  const getFirstName = (fullName: string) => {
    return fullName.split(" ")[0];
  };

  const handleLogoutInt = () => {
    clearFormStorage();
    handleLogout();
  };

  return (
    <>
      <S.DropdownProfile>
        <S.ButtonNotfication>
          <S.ImageComponent src={user.photo} />
          <S.UserName>{getFirstName(user.name)}</S.UserName>
        </S.ButtonNotfication>
        <S.ProfileContent>
          <DropdownMenuItem onClick={onOpenModal}>
            <S.ButtonItemNotfication>
              <User />
              <S.Text>Editar perfil</S.Text>
            </S.ButtonItemNotfication>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem>
            <S.ButtonItemNotfication onClick={handleLogoutInt}>
              <LogOut />
              <S.Text>Sair</S.Text>
            </S.ButtonItemNotfication>
          </DropdownMenuItem>
        </S.ProfileContent>
      </S.DropdownProfile>
    </>
  );
};

export default DropdownProfile;
